import "./TrustHighlightsBar.css";

const HIGHLIGHTS = [
  {
    id: "verified",
    tone: "blue",
    title: "NCID-Verified",
    subtitle: "Care professionals",
    icon: "shield",
  },
  {
    id: "commission",
    tone: "green",
    title: "Direct Hiring",
    subtitle: "Choose and connect directly",
    icon: "commission",
  },
  {
    id: "support",
    tone: "red",
    title: "Support Available",
    subtitle: "Contact our team for assistance",
    icon: "headset",
  },
  {
    id: "replacement",
    tone: "teal",
    title: "Replacement Assistance",
    subtitle: "Subject to applicable policy",
    icon: "refresh",
  },
];

function HighlightIcon({ name }) {
  const common = {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.85",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
  };

  switch (name) {
    case "shield":
      return (
        <svg {...common}>
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <path d="m9 12 2 2 4-4" />
        </svg>
      );
    case "commission":
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <path d="M16 8h-5a2.5 2.5 0 0 0 0 5h2a2.5 2.5 0 0 1 0 5H8" />
          <path d="M12 6.5v1.5M12 16v1.5" />
        </svg>
      );
    case "headset":
      return (
        <svg {...common}>
          <path d="M4 14v-2a8 8 0 0 1 16 0v2" />
          <rect x="2" y="12" width="4" height="7" rx="1.5" />
          <rect x="18" y="12" width="4" height="7" rx="1.5" />
          <path d="M16 19h-3a2 2 0 0 0 0 4" />
        </svg>
      );
    case "refresh":
      return (
        <svg {...common}>
          <path d="M3 12a9 9 0 0 1 15.5-6.4L21 8" />
          <path d="M21 3v5h-5" />
          <path d="M21 12a9 9 0 0 1-15.5 6.4L3 16" />
          <path d="M3 21v-5h5" />
        </svg>
      );
    default:
      return null;
  }
}

export default function TrustHighlightsBar() {
  return (
    <ul className="trust-highlights" aria-label="NEMA care highlights">
      {HIGHLIGHTS.map((item) => (
        <li key={item.id} className={`trust-highlights__item trust-highlights__item--${item.tone}`}>
          <span className="trust-highlights__icon" aria-hidden>
            <HighlightIcon name={item.icon} />
          </span>
          <div className="trust-highlights__copy">
            <strong className="trust-highlights__title">{item.title}</strong>
            <span className="trust-highlights__subtitle">{item.subtitle}</span>
          </div>
        </li>
      ))}
    </ul>
  );
}
